module.exports = __webpack_public_path__ + "static/vtf_hngl-webfont-879065bad38ac18f7e7ef4f436059e4f.ttf";